import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "common/hooks/useAuth";
import EnclosureForm from "./EnclosureForm";

function Enclosure() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user: currentUser } = useAuth();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "enclosures",
    id,
    {}
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate(currentUser?.isSuperadmin ? "/enclosures" : "/");
    }
  }, [setAlert, router, error, currentUser, t]);

  const onSubmit = useCallback(
    async (dataEnclosure: any) => {
      const newEnclosure = { ...dataEnclosure };

      try {
        if (newEnclosure.id) {
          await updateItem(newEnclosure.id, newEnclosure);
        } else {
          await saveItem(newEnclosure);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <EnclosureForm onSubmit={onSubmit} enclosure={item} />
  );
}

export default Enclosure;
